import { STATUS_META } from "@/lib/api";

export const StatusBadge = ({ status, size = "sm" }) => {
  const meta = STATUS_META[status] || STATUS_META.quotation;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="status-badge"
      style={{ background: meta.bg, color: meta.fg, borderColor: meta.bd }}
    >
      {meta.label}
    </span>
  );
};

export default StatusBadge;
